export default {
  state: () => ({
    fastCashbackGameIds: [],
    competitionsGameIds: [],
  }),
  mutations: {
    UPDATE_FAST_CASHBACK_GAME_IDS(state, value) {
      state.fastCashbackGameIds = value
    },
    UPDATE_COMPETITIONS_GAME_IDS(state, value) {
      state.competitionsGameIds = value
    },
  },
  getters: {
    isFastCashbackGame: (s) => (id) => s.fastCashbackGameIds.includes(id),
    isCompetitionGame: (s) => (id) => s.competitionsGameIds.includes(id),
  },
}
